/** 18px */
export const AXIS_TITLE_SIZE = 20;

/** 14px */
export const AXIS_TICK_SIZE = 16;

/** 24px */
export const CHART_TITLE_SIZE = 26;

/** Maximum number of MCLs before replacing them with `"-"` */
export const MAX_LABEL_LEN = 10;
